import { useMemo } from "react";
import { useAppDispatch } from "../../../../hooks/useTypedSelector";
import { useTranslatedColumns } from "../../../general/modules/commons/tableTranslation/translatedColumns";
import { RequestTableColumns } from "../../domain/columns/RequestTableColumns";
import { updateTiresetPosition } from "../../../tireset/infrastructure/slices/tireSetMutateSlice";
import { useAuthorization } from "../../../../hooks/useAuthorization";

export const useRequestsPageColumns = () => {
  const dispatch = useAppDispatch();
  const { hasRole } = useAuthorization();

  const translatedColumns = useTranslatedColumns(RequestTableColumns);

  const handleUpdatePosition = (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    row: Row<{ [p: object]: unknown }>,
    value: unknown,
  ): void => {
    try {
      const original = row.original as {
        source: { id: string | number };
      };

      void dispatch(
        updateTiresetPosition({
          position_id: value as number,
          id: original?.source?.id,
        }),
      );
    } catch (error) {
      console.error("Error during position update:", error);
    }
  };

  return useMemo(() => {
    const columnsWithUpdateData = [...translatedColumns];
    const positionColumnIndex = columnsWithUpdateData.findIndex(
      (column) => column.id === "source.position.id",
    );

    if (positionColumnIndex !== -1) {
      if (hasRole("dbh-manager") || hasRole("super-admin")) {
        columnsWithUpdateData[positionColumnIndex] = {
          ...columnsWithUpdateData[positionColumnIndex],
          meta: {
            ...columnsWithUpdateData[positionColumnIndex].meta,
            columnAction: "disabled",
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            updateData: handleUpdatePosition,
          },
        };
      } else if (hasRole("dealer-employee")) {
        columnsWithUpdateData.splice(positionColumnIndex, 1);
      }
    }

    return columnsWithUpdateData;
  }, [translatedColumns, dispatch]);
};
